"use strict";

import "./NotificationConfigCard.css";

import React from "react";
import ReactDOM from "react-dom";
import classnames from "classnames";

import lang from "vwa/lang";
import Button from "vwa/components/Button";
import Card from "vwa/components/Card";

import Toast from "vwa/components/Toast";

import {isValidNotificationConfig, isValidEventDescriptor} from "./../../../utils/notification";

import CriticalValueNotificationConfigForm from "./../CriticalValueNotificationConfigForm";

export default class NotificationConfigCard extends React.Component {
	
	constructor(props){
		super(props);
		this.initState();
	}
	
	initState(){
		this.state = { //formban módosított, de apiba még nem küldött adatok
			eventDescriptor: null,
			notificationConfig: null
		}
	}
	
	handleChange(eventDescriptor, notificationConfig){
		this.setState({
			eventDescriptor,
			notificationConfig
		}, _ => {
			if(this.getSaveButtonDisabled()){
				new Toast(lang.INVALID_CONFIGURATION, "orange");
			}
		});
	}
	
	save(){
		this.props.onSave(this.state.eventDescriptor, this.state.notificationConfig);
		this.setState({
			eventDescriptor: null,
			notificationConfig: null
		});
	}
	
	getSaveButtonDisabled(){
		return !isValidEventDescriptor(this.state.eventDescriptor) || !isValidNotificationConfig(this.state.notificationConfig);
	}
	
	render(){
		return(
			<Card className="NotificationConfigCard">
				<header>
					<Button
						icon="close"
						onClick={_ => this.props.onRemove()}
					/>
					<Button
						icon="check"
						disabled={this.getSaveButtonDisabled()}
						onClick={_ => this.save()}
					/>
				</header>
				<CriticalValueNotificationConfigForm
					dataTypes={this.props.dataTypes}
					vehicles={this.props.vehicles}
					onChange={(eventDescriptor, notificationConfig) => this.handleChange(eventDescriptor, notificationConfig)}
					notificationConfig={this.props.notificationConfig}
				/>
			</Card>
		);
	}
	
}

NotificationConfigCard.propTypes = {
	onSave: 			React.PropTypes.func,
	onRemove: 			React.PropTypes.func,
	dataTypes: 			React.PropTypes.array,
	vehicles: 			React.PropTypes.array,
	notificationConfig: React.PropTypes.object,
	eventDescriptor: 	React.PropTypes.object
};

NotificationConfigCard.defaultProps = {
	onSave: 			(eventDescriptor, notificationConfig) => {},
	onRemove: 			() => {},
	dataTypes: 			[],
	vehicles: 			[],
	notificationConfig: null,
	eventDescriptor: 	null
};


// WEBPACK FOOTER //
// ./src/view/CriticalValueNotifications/NotificationConfigCard/NotificationConfigCard.jsx